module.exports = __webpack_public_path__ + "static/mou-b82725ba85109ef10c129c43dbc24bff.jpg";